import { AbstractControl } from '@angular/forms';

export default function bankRouting(control: AbstractControl) {
  const routingNumber = control.value;

  if (!routingNumber) {
    return {
      bankRouting: true,
    };
  }

  // Has to be 9 digits
  const match = routingNumber.match('^\\d{9}$');
  if (!match) {
    return {
      bankRouting: true,
    };
  }

  // The values we will use to multiply the routing values to calculate the check digit
  const weights = [3, 7, 1];
  let sum = 0;

  for (let i = 0; i < 8; i++) {
    sum += parseInt(routingNumber[i], 10) * weights[i % 3];
  }

  if (!((10 - (sum % 10)) % 10 === parseInt(routingNumber[8], 10))) {
    return {
      bankRouting: true,
    };
  }

  return null;
}
